var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass:
        "mui-textfield mui-textfield--float-label mui-textfield--no-underline mui-textfield--inherit-color mui-textfield--advanced-filters mui-textfield--label-gray pb-1 border-b border-neutral-300",
    },
    [
      _c("input", {
        ref: "input",
        attrs: { type: "number", name: _vm.name },
        domProps: { value: _vm.value },
        on: {
          input: _vm.handleInput,
          blur: function ($event) {
            return _vm.$emit("blur")
          },
        },
      }),
      _vm._v(" "),
      _c("label", { domProps: { textContent: _vm._s(_vm.label) } }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }